/**
 * A simple object for storing and retrieving  the extra results from evaluating an elementRule.
 * Values are stored against a hash of the elementRule
 */
class RulesCache {

    constructor() {
        this.store = {};
    }

    /**
     * Stores the provided params against a a simple md5 hash of the elementRule
     * @param {Object} elementRule - The elementRule to cache values for
     * @param {Object} stateValues - The values used to evaluate the elementRule
     * @param {Object} rulesResults - The results of each rule in the elementRule
     * @param {Boolean} result - The overall result of the elementRule
     */
    cacheElementRuleValues = (elementRule, stateValues, rulesResults, result) => {
        this.store[elementRule.id] = { elementRule, stateValues, rulesResults, result };
    };

    /**
     * Return the stored stateValues for the given id
     * @param {String} id - The elementRule hash / id
     * @returns {Object} - The values used to evaluate the elementRule
     */
    getStateValuesForId = (id) => {
        return this.store[id].stateValues;
    };

    /**
     * Return the stored rulesResults for the given id
     * @param {String} id - The elementRule hash / id
     * @returns {Object} - The results of each rule in the elementRule
     */
    getRulesResultsForId = (id) => {
        // todo for some reason this seems to returning more ruleResults than that which belong to a particular rule
        return this.store[id].rulesResults;
    };

    /**
     * Return the stored elementRule for the given id
     * @param {String} id - The elementRule hash / id
     * @returns {Object} - The actual, complete elementRule
     */
    getElementRuleForId = (id) => {
        return this.store[id].elementRule;
    };

    /**
     * Return all the rule data for a rule ID
     * @param {String} id - The rule ID
     * @returns {Object} - The elementRule, stateValues and rulesResults for the rule
     */
    getAllRuleData = (id) => {
        return {
            elementRule: this.getElementRuleForId(id),
            stateValues: this.getStateValuesForId(id),
            rulesResults: this.getRulesResultsForId(id)
        };
    };

    /**
     * Return the cached rule data for the given elementId and ruleType
     * @param {String} elementId - The ID of the element
     * @param {String} ruleType - The type of rule to return, eg validation, visibility etc
     * @returns {Object} - The corresponding rule data
     */
    getRuleResult = (elementId, ruleType) => {
        return this.store[`${elementId}.${ruleType}`];
    };

}

const rulesCache = new RulesCache();

// export a singleton of the rulesCache
export { rulesCache };
